import App from './App.svelte';

import { router } from '@/libs/Router';
import { test as storageTest } from '@/helpers/storage';
import { init } from '@/helpers/auth';
import { states } from '@/stores';
import { routes, layouts, views, guards } from '@/routes';


states.push({ storage: storageTest() });


init();


router.init({
	routes: routes,
	layouts: layouts,
	views: views,
	guards: guards,
});


const app = new App({ target: document.body });

export default app;
